import { createSortedMapContext } from '@rimbu/sorted/map-custom';
const _defaultContext = createSortedMapContext();
export const SortedMap = Object.freeze({
    ..._defaultContext,
    createContext: createSortedMapContext,
    defaultContext() {
        return _defaultContext;
    },
});
//# sourceMappingURL=index.mjs.map